import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Pencil, Trash, Plus, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import ImageUpload from "../../components/ImageUpload";

const empty = {
  title: { en: "", gr: "" }, excerpt: { en: "", gr: "" }, body: { en: "", gr: "" },
  cover_image: "", author: "MP Sound Team", tags: [], published: true,
};

export default function AdminBlog() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/blog").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...editing, tags: typeof editing.tags === "string" ? editing.tags.split(",").map(t => t.trim()).filter(Boolean) : (editing.tags || []) };
    try {
      if (editing.id) await api.put(`/admin/blog/${editing.id}`, payload);
      else await api.post("/admin/blog", payload);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); }
  };

  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/blog/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-blog">
      <div className="flex items-center justify-between mb-8">
        <h1 className="display-font text-3xl font-black uppercase">Blog</h1>
        <button onClick={() => setEditing({ ...empty })} className="btn-primary"><Plus size={18} weight="bold" /> New</button>
      </div>

      <div className="grid gap-3">
        {items.map((p) => (
          <div key={p.id} className="card-dark p-4 flex items-center gap-4">
            {p.cover_image && <div className="w-16 h-16 shrink-0 overflow-hidden"><img src={p.cover_image} alt="" className="w-full h-full object-cover" /></div>}
            <div className="flex-1">
              <div className="display-font font-bold">{p.title.en}</div>
              <div className="mono-font text-xs text-gray-500 mt-1">/{p.slug} · {p.published ? "published" : "draft"}</div>
            </div>
            <button onClick={() => setEditing({ ...p, tags: (p.tags || []).join(", ") })} className="p-2 hover:text-[#ccff00]"><Pencil size={18} /></button>
            <button onClick={() => del(p.id)} className="p-2 hover:text-[#ff003c]"><Trash size={18} /></button>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <form onSubmit={save} className="bg-[#0a0a0c] border border-[#2a2a35] max-w-3xl w-full max-h-[90vh] overflow-auto p-6">
            <div className="flex justify-between items-center mb-5">
              <h2 className="display-font text-2xl font-bold">{editing.id ? "Edit" : "New"} post</h2>
              <button type="button" onClick={() => setEditing(null)}><X size={20} /></button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <input required placeholder="Title (EN)" className="input-dark" value={editing.title.en} onChange={(e) => setEditing({ ...editing, title: { ...editing.title, en: e.target.value } })} />
              <input placeholder="Title (GR)" className="input-dark" value={editing.title.gr} onChange={(e) => setEditing({ ...editing, title: { ...editing.title, gr: e.target.value } })} />
              <div className="sm:col-span-2">
                <ImageUpload value={editing.cover_image} onChange={(url) => setEditing({ ...editing, cover_image: url })} label="Cover image" />
              </div>
              <input placeholder="Author" className="input-dark" value={editing.author} onChange={(e) => setEditing({ ...editing, author: e.target.value })} />
              <input placeholder="Tags (comma separated)" className="input-dark" value={editing.tags} onChange={(e) => setEditing({ ...editing, tags: e.target.value })} />
              <textarea placeholder="Excerpt (EN)" className="input-dark sm:col-span-2" value={editing.excerpt.en} onChange={(e) => setEditing({ ...editing, excerpt: { ...editing.excerpt, en: e.target.value } })} />
              <textarea placeholder="Excerpt (GR)" className="input-dark sm:col-span-2" value={editing.excerpt.gr} onChange={(e) => setEditing({ ...editing, excerpt: { ...editing.excerpt, gr: e.target.value } })} />
              <textarea placeholder="Body (EN)" className="input-dark sm:col-span-2 min-h-[160px]" value={editing.body.en} onChange={(e) => setEditing({ ...editing, body: { ...editing.body, en: e.target.value } })} />
              <textarea placeholder="Body (GR)" className="input-dark sm:col-span-2 min-h-[160px]" value={editing.body.gr} onChange={(e) => setEditing({ ...editing, body: { ...editing.body, gr: e.target.value } })} />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={editing.published} onChange={(e) => setEditing({ ...editing, published: e.target.checked })} /> Published</label>
            </div>
            <div className="mt-6 flex gap-3 justify-end">
              <button type="button" className="btn-outline" onClick={() => setEditing(null)}>Cancel</button>
              <button type="submit" className="btn-primary">Save</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
